import { createIconSetFromFontello } from '@expo/vector-icons';
import fontelloConfig from './fontello/config.json';

const Fontello = createIconSetFromFontello(fontelloConfig, 'fontello', 'fontello.ttf');

export default Fontello;
